import React, { useRef, useState, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  List, ListItem, ListItemText,
  Dialog, DialogTitle, DialogContent, DialogActions, Toolbar,
  Button, TextField,
  useTheme,
} from '@mui/material';
import AddCircle from '@mui/icons-material/AddCircle';
import _union from 'lodash/union';

import {
  createFavoriteAction,
  getFavoritesAction, updateFavoriteAction, useFavorites
} from '@ivymobi/orbit-core/business/favorite';

import { TenantContext, UserContext } from '../orbit-context';
import { documentEventAction } from '@ivymobi/orbit-core/business/document';
import { useTranslation } from 'react-i18next';


export function NewFavFolderDialog({ onClose, onSubmit }) {
  const ref = useRef(null);

  const handleOnChange = (e) => { ref.current = e.target.value; };
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(ref.current);
  };
  var [t] = useTranslation();
  return <>
    <DialogTitle>  {t('common.createFavorites')} </DialogTitle>
    <form onSubmit={handleSubmit}>
      <DialogContent>
        <TextField label={ t('common.name')} placeholder={ t('common.collectionName')} fullWidth
          onChange={handleOnChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('YBT-ADMIN.YBT-ADMIN-020103.YBT-ADMIN-02010310')}</Button>
        <Button color='primary' type="submit" > { t('common.confirm')} </Button>
      </DialogActions>
    </form>
  </>;
}

export default function FavorDialog(props) {
  const { selectedIds, onClose, onPre, onAddUploadFile } = props;
  const dispatch = useDispatch();
  const theme = useTheme();
  const user = useContext(UserContext);
  const tenant = useContext(TenantContext);
  const { ids, data } = useFavorites(user.user, tenant);
  const [mode, setMode] = useState('normal');

  useEffect(() => {
    dispatch(getFavoritesAction({ user, tenant }));
  }, []);

  const handleAddFav = (favId) => () => {
    const fav = data[favId];
    console.log("fav==", fav, selectedIds)
    if (onPre) {
      onPre(favId).then(res => {
        if (onAddUploadFile) {
          onAddUploadFile(res)
        }
          
        let arr = [];
        res.map(item => {
          arr.push(item.id)
        })

        dispatch(updateFavoriteAction({
          user, tenant,
          collection: {
            ...fav,
            documents: _union(fav.documents.concat(arr))
          }
        })).then(() => {
          props.setFavSuccess(true);
          // @todo 暂时只支持一个文件的统计， 因为 ui 现在还不支持多选
          // return dispatch(documentEventAction({ user, tenant, document: { id: selectedIds[0] }, type: 'fav' }));
        });
      });
      // console.log("res===",res)
    } else {
      dispatch(updateFavoriteAction({
        user, tenant,
        collection: {
          ...fav,
          documents: _union(fav.documents.concat(selectedIds))
        }
      })).then(() => {
        props.setFavSuccess(true);
        // @todo 暂时只支持一个文件的统计， 因为 ui 现在还不支持多选
        return dispatch(documentEventAction({ user, tenant, document: { id: selectedIds[0] }, type: 'fav' }));
      });
    }

    onClose();
  };

  const handleClose = () => { setMode('normal'); };
  const handleNewFav = () => { setMode('new'); };
  const handleCreateFav = (name) => {
    dispatch(createFavoriteAction({ user, tenant, name }));
    setMode('normal');
  };
  var [t] = useTranslation();
  return <>
    <DialogTitle> {t('menu.favorites')} </DialogTitle>
    <DialogContent>
      <List dense>
        {ids.map(favId => (
          <ListItem key={favId} button onClick={handleAddFav(favId)}>
            <img src="/fileTypes/folder.svg"
              style={{ height: '32px', width: '32px', marginRight: '16px' }}
            />
            <ListItemText primary={data[favId].name} />
          </ListItem>
        ))}
      </List>
    </DialogContent>
    <Toolbar
      style={{
        display: 'flex', justifyContent: 'space-between',
        backgroundColor: theme.palette.background.default
      }}
    >
      <Button startIcon={<AddCircle />} color="primary" onClick={handleNewFav}>
      {t('common.createFavorites')}
      </Button>
      <Button onClick={onClose}>{t('YBT-ADMIN.YBT-ADMIN-020103.YBT-ADMIN-02010310')}</Button>
    </Toolbar>
    <Dialog open={mode === 'new'} maxWidth="xs" fullWidth onClose={handleClose}>
      <NewFavFolderDialog onClose={handleClose} onSubmit={handleCreateFav} />
    </Dialog>
  </>;
}
